export default "/images/d558d56a8bd68d34d37f3eacc9ed9279.avif";